// @ts-check
import { BellRing, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useToast } from '../../context/ToastContext';
import adminWholesaleService from '../../services/adminWholesaleService';
import { formatDay } from '../../utils/wholesale';
import { card } from './shared';

/**
 * Everything due today or earlier. `compact` is the dashboard version (no heading box).
 * @param {{reminders: any[], onChanged: () => void, compact?: boolean}} props
 */
const RemindersPanel = ({ reminders, onChanged, compact = false }) => {
  const toast = useToast();

  const done = async (reminder) => {
    try {
      await adminWholesaleService.markReminderDone(reminder.id);
      onChanged();
    } catch (err) {
      toast.error(err.message || 'Could not clear the reminder');
    }
  };

  if (reminders.length === 0) {
    return compact ? null : (
      <div className={`${card} p-4 text-sm text-muted-foreground mb-6`}>Nothing due. Reminders appear here on day 4 and day 10 after a send, when a quote sits unanswered for 7 days, and on any follow-up date you set.</div>
    );
  }

  return (
    <div className={`${card} mb-6`}>
      <div className="flex items-center gap-2 px-4 py-3 border-b border-border">
        <BellRing size={18} className="text-amber-600" />
        <h2 className="text-sm font-semibold">
          {reminders.length} follow-up{reminders.length === 1 ? '' : 's'} due
        </h2>
      </div>
      <ul className="divide-y divide-border">
        {reminders.map((r) => (
          <li key={r.id} className="flex items-center gap-3 px-4 py-2.5">
            <div className="flex-1 min-w-0">
              <Link to={`/wholesale/${r.partner_id}`} className="text-sm font-medium hover:underline">
                {r.message}
              </Link>
              <p className="text-xs text-muted-foreground">
                Due {formatDay(r.due_on)}
                {r.overdue_days > 0 ? ` · ${r.overdue_days} day${r.overdue_days === 1 ? '' : 's'} overdue` : ''}
              </p>
            </div>
            <button
              onClick={() => done(r)}
              className="flex items-center gap-1 px-2.5 py-1 text-xs border border-input rounded-lg hover:bg-accent"
              title="Mark done"
            >
              <Check size={14} /> Done
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RemindersPanel;
